export default "__VITE_ASSET__Df5a60Jn__"